import styled from "styled-components";
import { Link } from "react-router-dom";
import { MenuOutlined } from "@ant-design/icons";
import { theme } from "../../styles/theme";

export const HeaderSection = styled("header")<{ $scrolled?: boolean }>`
  position: sticky;
  top: 0;
  z-index: 1000;
  width: 100%;
  padding: 0.875rem 0;
  background: ${(p) => (p.$scrolled ? "rgba(255, 255, 255, 0.97)" : theme.colors.background)};
  backdrop-filter: blur(12px);
  border-bottom: 1px solid ${(p) => (p.$scrolled ? theme.colors.border : "transparent")};
  box-shadow: ${(p) => (p.$scrolled ? theme.shadows.sm : "none")};
  transition: all 0.25s ease;

  .ant-row-space-between {
    align-items: center;
    text-align: center;
  }
`;

export const LogoContainer = styled(Link)`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

export const LogoText = styled("span")`
  font-size: 1.125rem;
  font-weight: 700;
  color: ${theme.colors.text};
  letter-spacing: -0.02em;

  span {
    color: ${theme.colors.primary};
  }

  @media only screen and (max-width: 480px) {
    display: none;
  }
`;

export const NavLink = styled("div")`
  display: inline-block;
  text-align: center;
`;

export const Burger = styled("div")`
  @media only screen and (max-width: 890px) {
    display: block;
  }

  display: none;
  cursor: pointer;
  padding: 0.5rem;

  svg {
    fill: ${theme.colors.primary};
  }
`;

export const NotHidden = styled("div")`
  display: flex;
  align-items: center;
  gap: 0.25rem;

  @media only screen and (max-width: 890px) {
    display: none;
  }
`;

export const Menu = styled("h5")`
  font-size: 1.25rem;
  font-weight: 600;
  text-align: center;
  color: ${theme.colors.text};
`;

export const CustomNavLinkSmall = styled(NavLink)`
  font-size: 0.9375rem;
  font-weight: 500;
  color: ${theme.colors.textSecondary};
  transition: color 0.2s ease;
  margin: 0 1.25rem;

  @media only screen and (max-width: 768px) {
    margin: 1.25rem 0;
  }
`;

export const Label = styled("span")`
  font-weight: 500;
  color: ${theme.colors.textSecondary};
  text-align: right;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

export const Outline = styled(MenuOutlined)`
  font-size: 22px;
  color: ${theme.colors.primary};
`;

export const Span = styled("span")`
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover,
  &:active,
  &:focus {
    color: ${theme.colors.primary};
  }
`;

export const NavCTA = styled("div")`
  margin-left: 0.5rem;

  button {
    margin-top: 0;
    max-width: 140px;
    padding: 10px 20px;
    font-size: 0.875rem;
  }
`;
